import { useCallback, type ReactNode } from 'react'
import { useMsal, useAccount } from '@azure/msal-react'
import {
  InteractionRequiredAuthError,
  InteractionStatus,
} from '@azure/msal-browser'
import { apiRequest } from '@/services/msalConfig'
import { AuthContext } from './authContext'

export function AuthProvider({ children }: { children: ReactNode }) {
  const { instance, accounts, inProgress } = useMsal()
  const account = useAccount(accounts[0] || null)

  const isAuthenticated = account != null && inProgress === InteractionStatus.None

  const login = useCallback(async () => {
    await instance.loginRedirect(apiRequest)
  }, [instance])

  const logout = useCallback(() => {
    instance.logoutRedirect()
  }, [instance])

  const getAccessToken = useCallback(async (): Promise<string | null> => {
    if (!account) return null

    try {
      const response = await instance.acquireTokenSilent({ ...apiRequest, account })

      return response.accessToken
    } catch (e) {

      if (e instanceof InteractionRequiredAuthError) {
        await instance.acquireTokenRedirect(apiRequest)
        return null
      }

      throw e
    }
  }, [instance, account])

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        account,
        login,
        logout,
        getAccessToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
